import React, { Component } from "react";
import { connect } from "react-redux";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";

import Alert from "react-bootstrap/Alert";
import Container from "react-bootstrap/Container";

import Router from "./Router.tsx";

import { setAlertVisibility, setAlert } from "../actions/alertActions";
import { setLanguage } from "../actions/languageActions";
import { getUserLanguage } from "./utils/Utils";

import "../styles/main.scss";

const baseUrl = "/:locale([a-z]{2})?";
const fallbackLanguages = ["en", "es", "fr", "pt"];

const updateLanguageFormat = (lang) => {
  let updatedLanguage = lang.split("/");
  return `/${updatedLanguage[2]}`;
};

const formatLocale = (lang) => lang.split("_")[0].replace("/", "");
const needsChangeURL = (lang) => (lang.split("/")[1] || "").length > 3;
const stripFirstPathSegment = (path) => {
  const segments = path.split("/").filter(Boolean);
  if (segments.length <= 1) return "/";
  return `/${segments.slice(1).join("/")}`;
};

const formatLanguage = (pathname, locale) => {
  // Get the first segment after the leading slash
  const firstPathSegment = pathname.split("/")[1] || "";

  // If the segment contains an underscore, extract the part before it as the locale
  if (firstPathSegment.includes("_")) {
    return firstPathSegment.split("_")[0];
  }

  return locale;
};

const normalizeLocaleCode = (locale) =>
  (locale || "")
    .toLowerCase()
    .split(/[-_]/)[0];


class App extends Component {

  render() {
    const webLateLanguages = (this.props.languages || [])
      .map((language) => {
        if (typeof language === "string") return language;

        return (
          language.languageCode ||
          language.code ||
          language.locale ||
          language.value ||
          ""
        );
      })
      .filter(Boolean)
      .map(normalizeLocaleCode);

    const loadedTranslationLanguages = Object.keys(this.props.translationCatalog || {}).map(normalizeLocaleCode);
    const availableLanguages = Array.from(
      new Set([...webLateLanguages, ...loadedTranslationLanguages, ...fallbackLanguages])
    );
    
    return (
      <>
        <Container fluid={true} className="body">
          <BrowserRouter>
            <Switch>
              <Route path={baseUrl}>
                {({ match, location }) => {
                  const params = match ? match.params : {};
                  let { locale = this.props.locale || getUserLanguage() } = params;
                  let { pathname } = location;

                  if(pathname.includes("confirmEmail")){
                    locale = formatLanguage(pathname, locale);
                  }
                  
                  if (
                    needsChangeURL(pathname) &&
                    !pathname.includes("unsubscribe") &&
                    !pathname.includes("confirmEmail")
                  ) {
                    if ((pathname.match(/\//g) || []).length === 2) {
                      locale = formatLocale(pathname);
                      return (
                        <Redirect
                          to={`/${locale + updateLanguageFormat(pathname)}`}
                        />
                      );
                    } else {
                      return <Redirect to={`/${locale + pathname}`} />;
                    }

                  }

                  if (!availableLanguages.includes(normalizeLocaleCode(locale)) && !(pathname.includes("unsubscribe"))) {
                    locale = "en";
                    pathname = stripFirstPathSegment(pathname);
                  }

                  if (!pathname.includes(`/${locale}`)  && !(pathname.includes("unsubscribe"))) {
                    if (pathname === "/") return <Redirect to={`/${locale}/terms&conditions`} />;
                    else return <Redirect to={`/${locale + pathname}`} />;
                  }

                  
                   if (locale && !pathname.includes("unsubscribe")) {
                     locale = formatLanguage(pathname, locale);
                   }
                  
                  return <Router locale={locale} pathname={pathname} />;
                }}
                
              </Route>
            </Switch>
          </BrowserRouter>
        </Container>
        <Alert
          id="mainAlert"
          variant={this.props.alertVariant}
          show={this.props.alertVisible}
          onClose={() => this.props.setAlertVisibility(false)}
          dismissible
        >
          {typeof this.props.alertContent === "string" ? (
            this.props.alertContent
          ) : (
            <>
              <h6>{this.props.alertContent.title}</h6>
              <p>{this.props.alertContent.body}</p>
            </>
          )}
        </Alert>
      </>
    );
  }
}

const mapStateToProps = state => ({
  locale: state.i18n.locale,
  languages: state.language.languages,
  translation: state.language.translation,
  translationCatalog: state.i18n.translations,
  alertVisible: state.alert.alertVisible,
  alertContent: state.alert.alertContent,
  alertVariant: state.alert.alertVariant,
  alertClose: state.alert.alertClose,
});



export default connect(mapStateToProps, {
  setAlert,
  setAlertVisibility,
  setLanguage,
})(App);
